export const LEGAL_CANCELLATION_PROCEDURE: string = `

### <!--= ++sectionIndex -->. Cancellation Procedure

#### <!--= sectionIndex -->.1 Cancellation via Model Cancellation Form
Alternatively, if you wish to cancel your subscription, you may use our “Model Cancellation Form” provided below. Please fill out the required fields and send it back to us via mail or post.

Please ensure to complete the form accurately to aid in swift processing of your request.

<div style="padding: 36px; box-shadow: 0px 4px 11px 0px rgba(0,0,0,0.25); border-radius: 16px;">

**Model Cancellation Form**

*(Complete and return this form only if you wish to withdraw from the contract.)*

To:
<!-- for (const addressLine of company.address) { -->
<!--= addressLine -->
<!-- } -->

or,

Email: <!--= company.mail -->

I/We (&#42;) hereby give notice that I/We (&#42;) withdraw from my/our (&#42;) contract of sale for the following goods (&#42;)/provision of the following service (&#42;),

Ordered on (&#42;)/Received on (&#42;),

Name of consumer(s),

Address of consumer(s),

Signature of consumer(s)
*(only if this form is notified on paper)*

Date

*(&#42;) Delete as appropriate*

</div>
<br>

<!-- if (cancellationPolicy.selfCancellation) { -->

#### <!--= sectionIndex -->.2 <!--= cancellationPolicy.selfCancellation.heading -->

<!-- for (const textLine of cancellationPolicy.selfCancellation.texts) { -->
<!--= textLine -->

<!-- } -->

<!-- } -->
`;
